import React from 'react'
import { useHotkeys } from 'react-hotkeys-hook'
import { NavLink, useHistory, useLocation } from 'react-router-dom'

const mod = (n: number, m: number) => ((n % m) + m) % m;

const SmartNavLinks = (props: {
	navLinks: any,
}) => {

	const {
		navLinks,
	} = props

	const history = useHistory()
	const location = useLocation()

	useHotkeys('p', () => history.push(navLinks[(navLinks.findIndex((navLink: any) => navLink.to === location.pathname) + 1) % navLinks.length].to), { keyup: true, enableOnContentEditable: true })
	useHotkeys('shift+p', () => history.push(navLinks[mod((navLinks.findIndex((navLink: any) => navLink.to === location.pathname) - 1), navLinks.length)].to), { keyup: true, enableOnContentEditable: true })

	return (
		<React.Fragment>
			{navLinks.map((navLink: any, i: number) => (
				<React.Fragment>
					<NavLink style={{ textAlign: 'center', marginRight: i < navLinks.length ? 34 : undefined, marginLeft: i > 0 ? 34 : undefined }} to={navLink.to}>{navLink.title}</NavLink>
					{i < navLinks.length - 1 ? ' • ' : undefined}
				</React.Fragment>
			))}
		</React.Fragment>
	)
}

export default SmartNavLinks

// TODO : Change css into mui styles